import React, {PropTypes} from 'react';
import {AddContentToolbar} from '../AddContentToolbar';
import {detailsContentComponent} from '../details';
import {List} from 'immutable';
import {ContentToolBar} from '../ContentToolBar';

export class DetailsEdit extends React.Component {
  static propTypes = {
    style: PropTypes.object,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {value: List([])};

  shouldComponentUpdate(nextProps) {
    return this.props.value !== nextProps.value;
  }

  render() {
    const {value, onChange, style = {}} = this.props;

    return (
      <div style={style}>
        {value ? value.items.map((item, key) => (
          <div key={key} className={style.content}>
            <ContentToolBar className={style.toolbar}
                            remove={() => onChange(value.remove(item))}
                            moveUp={key > 0}
                            moveDown={key < value.items.size-1}
                            onMoveUp={() => onChange(value.move(key, key-1))}
                            onMoveDown={() => onChange(value.move(key, key+1))}
            />
            {React.createElement(detailsContentComponent(item.type), {
              key,
              node: item,
              onChange: (newItem) => {
                onChange(value.updateListItem(item, newItem));
              }
            })
            }
          </div>
          )) : null}
        <AddContentToolbar onAdd={(newItem) => onChange(value.push(newItem))}/>
      </div>
    );
  }
}

export default DetailsEdit;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/ListContentComponent/DetailsEdit.js